<template>
    <div name="medical-info" class="wrapper">
        <file-view 
            v-if="selectedHistory"
            :select1List="select1List"
            :select2List="select2List"
            :select3List="select3List"
            :history="selectedHistory"
            :selectedCategory="selectedCategory"
            :token="token"
            @onClose="closefileViewModal"
        />
        <div class="page" v-else> 
            <error-modal 
                v-if="error"
                :error="error"
                @onClose="onErrorModalClose"
            />
            <div class="button-header">
                <img @click="back" style="width: 22px; cursor: pointer;" src="../assets/arrow_back.png" />
                <span class="button-header-text">이용내역</span>
            </div>
            <div class="settlement-banner">
                <span class="settlement-banner-text"><span style="font-weight: 600;">연말 정산용 의료기기 지출 명세서</span><br>통합 영수증 다운로드</span>
                <div class="settlement-go-button" @click="goSettlement">바로가기</div>
            </div>
            <div class="select-header-bar" style="margin-top: 16px;">
                <span class="total-medical-count-text">전체 {{ diabetes_histories.total_count }}</span>
                <small-select-box 
                    v-if="isSelect"
                    :options="options"
                    :selectedIndex="selectedIndex"
                    :placeHolder="''"
                    :title="'등록된 환자 목록'"
                    @select="selectProfile"
                />
            </div>
            <div class="info-guide-box" style="margin-top: 16px;">
                <span class="info-guide-text"><span style="font-weight: 600;">확인되지 않는 내역</span>은 고객센터로 문의해주세요.</span>
            </div>
            <div class="medical-list-box" v-if="diabetes_histories.total_count > 0" style="margin-top: 16px;">
                <div class="medical-box"   style="margin-bottom: 8px;" v-for="( history, index) in diabetes_histories.histories">
                    <span class="medical-box-time-text">{{ convertTimeToString(history.time) }}</span>
                    <div class="medical-box-row" style="margin-top: 8px;">
                        <span class="medical-box-name-text">{{ history.name }}</span>
                        <div class="button-wrapper">
                            <button class="medical-box-button" v-if="history.has_prescriptions" @click="select(history, 0)">진료 서류</button>
                            <button class="medical-box-button" style="margin-left: 9.5px;" v-if="history.has_purchase_docs" @click="select(history, 1)">구매 서류</button>
                        </div>
                    </div>

                </div>
            </div>
            <div class="no-medical-box" v-else style="margin-top: 16px;">
                <img style="width: 87.689px;" src="../assets/document.png" />
                <span class="no-medical-text">진료 내역이 없어요.</span>
            </div>
        </div>
    </div>
</template>

<script>
// 내역 가져오기 
import {mapState} from 'vuex';
import Constant from '@/constant';
import ErrorModal from '@/components/modals/ErrorModal';
import cookies from '@/utilities/cookie.js';
import convert from '@/utilities/convert.js'
import FileView from '@/components/organisms/contract/FileView';
import SmallSelectBox from '@/components/atoms/SmallSelectBox.vue';


export default {
    name: 'medicalInfo',
    computed: mapState(['diabetes_profiles', 'diabetes_histories', 'diabetes_documents']),
    components: {
        ErrorModal,
        FileView,
        SmallSelectBox
    },
    data: function()
    {
        return {
            token: null,
            error: null,
            selectedHistory: null,
            select1List: [],
            select2List: [],
            select3List: [],
            options: ['모든 환자'],
            selectedIndex: 0,
            isSelect: false,
            selectedCategory: 0
        }
    },
    mounted: function()
    {
        this.topFunction();
        ChannelIO('shutdown')
        this.token = cookies.getLocalStorage("access_token");
        if(this.token === null || this.token === undefined || this.token === '')
        {
            this.token = cookies.deleteLocalStorage("access_token");
            this.$router.push({path: '/', query: {returnUrl: 'info'}})
        }
        else
        {
            this.$store.dispatch(Constant.FETCH_PROFILES, {token: this.token})
                .then(() => {
                   
                    this.diabetes_profiles.forEach(data => {
                        this.options.push(data.profile.name)
                    });
                    this.isSelect = true;
                }) 
                .catch(() => {
                    this.token = cookies.deleteLocalStorage("access_token");
                    this.$router.push({path: '/', query: {returnUrl: 'info'}})
                })

            
            // 유효성 체크    
            this.$store.dispatch(Constant.FETCH_USAGE, {profile_id: null, token: this.token})
                .then(() => {

                }) 
                .catch(() => {
                    this.token = cookies.deleteLocalStorage("access_token");
                    this.$router.push({path: '/', query: {returnUrl: 'info'}})
                })
        }
    },  // mounted
    methods: {
        goSettlement: function()
        {
            this.$router.push({path: '/settlement'})
        },
        topFunction: function() {
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        }, 
        selectProfile: function(select)
        {
            this.selectedIndex = select;

            this.$store.dispatch(Constant.FETCH_USAGE, {profile_id: select === 0 ? null : this.diabetes_profiles[this.selectedIndex - 1].profile.id, token: this.token})
                .then(() => {

                }) 
                .catch(() => {
                    this.token = cookies.deleteLocalStorage("access_token");
                    this.$router.push({path: '/', query: {returnUrl: 'info'}})
                })
        },
        back: function()
        {
            this.$router.push({path: '/home'})
        },
        convertTimeToString: function(time)
        {
            return convert.formatTimestamp(time)
        },
        select: function(history, selected)
        {
            this.selectedCategory = selected;

            // document 호출 
            this.$store.dispatch(Constant.FETCH_DOCUMENTS, {reception_numbers: history.reception_number, token: this.token})
            .then(() => {
                this.select1List = [];
                this.select2List = [];
                this.select3List = [];

                if(this.diabetes_documents.prescriptions.length > 0)
                {
                    this.select1List.push('진료 서류')
                    this.diabetes_documents.prescriptions.forEach(element => {
                        this.select2List.push(element.name);
                    });
                }
                if(this.diabetes_documents.purchase_docs.length > 0)
                {
                    this.select1List.push('구매 서류')
                    if(this.diabetes_documents.prescriptions.length > 0)
                    {
                        this.diabetes_documents.purchase_docs.forEach(element => {
                            this.select3List.push(element.name);
                        });
                    }
                    else
                    {
                        if(this.selectedCategory === 1)
                        {
                            this.selectedCategory = 0;
                        }   

                        this.diabetes_documents.purchase_docs.forEach(element => {
                            this.select2List.push(element.name);
                        });
                    }

                }

                this.selectedHistory = history;
            }) 
            .catch(() => {
                // this.token = cookies.deleteLocalStorage("access_token");
                // this.$router.push({path: '/', query: {returnUrl: 'info'}})
            })

        },
        closefileViewModal: function()
        {
            this.selectedCategory = 0;
            this.selectedHistory = null;
        }
    } // methods
}
</script>

<style scoped>
    .wrapper {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .page {
        width: 100%;
        background: #FFF;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        box-sizing: border-box;
        padding: 0 16px;
    }

    @media (min-width: 600px) {
        .page {
            width: 600px;
        }
    }

    .button-header {
        width: 100%;
        height: 48px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        box-sizing: border-box;
    }
    .button-header-text {
        color: var(--primary-color1, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        margin-left: 16px;
    }
    .select-header-bar {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .info-guide-box {
        width: 100%;
        background: var(--Gray-20, #F3F5F8);
        padding: 20px 16px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
    }
    .info-guide-text {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
    .medical-list-box {
        width: 100%;
        display: flex;
        flex-direction: column;
        padding-bottom: 18px;
        box-sizing: border-box;
    }
    .medical-box {
        width: 100%;
        border-radius: 6px;
        border: 1px solid #E8EAEE;
        background: #FFF;
        flex-shrink: 0;
        padding: 20px 16px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
    }
    .medical-box-time-text {
        color: var(--primary-color1, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
    .medical-box-row
    {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
    }
    .medical-box-name-text {
        color: var(--primary-color1, #1E1E1E);
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }
    .button-wrapper {
        display: flex;

    }
    .medical-box-button {
        border-radius: 100px;
        border: 1px solid var(--gray-30-stroke, #E8EAEE);
        background: var(--Gray-20, #F3F5F8);
        display: flex;
        box-sizing: border-box;
        height: 32px;
        padding: 6px 8px;
        justify-content: center;
        align-items: center;
        gap: 10px;
        cursor: pointer;
        flex-shrink: 0;

        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;

    }
    .total-medical-count-text {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: 28px; /* 140% */
    }
    .no-medical-box {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        padding-top: 80px;
    }
    .no-medical-text {
        color: var(--Gray-50, #A3AAB6);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 24.5px; /* 136.111% */
        margin-top: 50px;
    }

    .settlement-banner {
        border-radius: 6px;
        background: var(--Blue-04_Light-blue, #E5F0FC);
        padding: 20px 16px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        margin-top: 8px;
    }
    .settlement-banner-text {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }
    .settlement-go-button {
        border-radius: 100px;
        background: var(--Blue-01_Primary-blue, #008DEF);
        color: var(--Gray-00, #FFF);
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        width: 72px;
        height: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/page/MedicalInfo.vue